import { Url, URLS } from '@wix/da-url';
import { ModalType } from '../Modals/redux/types';
const submitMenuItems = [
    {
        type: 'deviation',
        label: 'siteHeader.deviation',
        link: URLS.SUBMIT,
        imageFileName: 'deviation-2x.png',
        imageMarginBottom: 10
    },
    {
        type: 'status',
        label: 'siteHeader.statusUpdate',
        verificationAction: 'submitstatus',
        modalType: ModalType.STATUS_UPDATE,
        imageFileName: 'status-update-2x.png',
        imageMarginBottom: 20,
        imageMarginLeft: 30
    },
    {
        type: 'journal',
        label: 'siteHeader.journal',
        verificationAction: 'submitjournal',
        modalType: ModalType.JOURNAL,
        imageFileName: 'journal-2x.png',
        imageMarginBottom: 32
    },
    {
        type: 'literature',
        label: 'siteHeader.literature',
        modalType: ModalType.LITERATURE,
        imageFileName: 'literature-2x.png',
        imageMarginBottom: 32
    },
    {
        type: 'commission',
        label: 'siteHeader.commission',
        verificationAction: 'submitcommission',
        modalType: ModalType.COMMISSION,
        modalOptions: {
            params: {
                redirectOnSubmit: true
            }
        },
        imageFileName: 'commission-2x.png',
        imageMarginBottom: 32
    },
    {
        type: 'poll',
        label: 'siteHeader.poll',
        verificationAction: 'submitpoll',
        modalType: ModalType.POLL_EDIT,
        imageFileName: 'poll-2x.png',
        imageMarginBottom: 32
    },
    {
        type: 'tier',
        label: 'siteHeader.tier',
        link: URLS.ROOT,
        modalType: ModalType.TIER_EDIT,
        modalOptions: {
            wrapInModal: false
        },
        isNew: true,
        imageFileName: 'subscription-2x.png',
        imageMarginBottom: 32
    },
    {
        type: 'dreamup',
        label: 'siteHeader.dreamup',
        link: Url.dreamupLink(),
        isNew: true,
        imageFileName: 'dreamup-2x.png',
        imageMarginBottom: 32
    }
];
export const desktopSubmitMenuItems = [
    'deviation',
    'dreamup',
    'status',
    'journal',
    'literature',
    'tier'
].map((type)=>submitMenuItems.find((item)=>item.type === type));
// mobile has fewer items in different order
export const mobileSubmitMenuItems = [
    'deviation',
    'dreamup',
    'status'
].map((type)=>submitMenuItems.find((item)=>item.type === type));
export const submitButtonMenuItem = {
    type: 'submitbutton',
    link: Url.buildFromPath(URLS.SUBMIT)
};
